module.exports = __webpack_public_path__ + "img/skill-dive-logo.08567bd6.png";